'use client';

import { c as _c } from "react/compiler-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHiveIconSmallLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom';
import { faChevronDown } from '@awesome.me/kit-94e593bf23/icons/sharp/light';
import Tooltip from '@/app/_components/Tooltip';
const HelpHeader = t0 => {
  const $ = _c(20);
  const {
    title: t1,
    showBack: t2,
    onBack,
    showMinimize: t3,
    onMinimize,
    rightIcon: t4
  } = t0;
  const title = t1 === undefined ? "Welcome to hive" : t1;
  const showBack = t2 === undefined ? false : t2;
  const showMinimize = t3 === undefined ? false : t3;
  const rightIcon = t4 === undefined ? null : t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FontAwesomeIcon icon={faHiveIconSmallLight} className="text-primary text-base" aria-hidden="true" />;
    $[0] = t5;
  } else {
    t5 = $[0];
  }
  let t6;
  if ($[1] !== title) {
    t6 = <h2 id="help-widget-title" className="text-base font-light truncate">{title}</h2>;
    $[1] = title;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] !== rightIcon) {
    t7 = rightIcon && <FontAwesomeIcon icon={rightIcon} className="text-primary text-base" aria-hidden="true" />;
    $[3] = rightIcon;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== t6 || $[6] !== t7) {
    t8 = <div className="flex items-center gap-2">{t5}{t6}{t7}</div>;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== onMinimize || $[9] !== showMinimize) {
    t9 = showMinimize && <Tooltip content="Minimize shopping assistant." side="bottom" mobileMode="disabled"><button onClick={onMinimize} className="text-light hover:text-primary transition-colors" aria-label="Minimize shopping assistant"><FontAwesomeIcon icon={faChevronDown} className="text-sm" /></button></Tooltip>;
    $[8] = onMinimize;
    $[9] = showMinimize;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== onBack || $[12] !== showBack) {
    t10 = showBack && <button onClick={onBack} className="text-2xs underline hover:text-primary transition-colors">Help Center</button>;
    $[11] = onBack;
    $[12] = showBack;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t9) {
    t11 = <div className="flex items-center gap-3">{t9}{t10}</div>;
    $[14] = t10;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11 || $[18] !== t8) {
    t12 = <header className="flex items-center justify-between px-3 py-3 border-b border-gray-10 bg-gray-3">{t8}{t11}</header>;
    $[17] = t11;
    $[18] = t8;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  return t12;
};
export default HelpHeader;